import React, { useState, useEffect } from 'react';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-deep-black/95 backdrop-blur-lg border-t border-white/10 p-4 z-50">
      <div className="container-custom">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-white/80 text-sm">
            <p>
              Wir verwenden Cookies, um dein Erlebnis auf unserer Website zu verbessern.
              Durch die weitere Nutzung stimmst du der Verwendung von Cookies zu.
              Weitere Informationen findest du in unserer{' '}
              <a href="/datenschutz" className="text-hot-pink hover:text-accent-purple transition-colors">
                Datenschutzerklärung
              </a>
              .
            </p>
          </div>
          <div className="flex gap-4">
            <button
              onClick={acceptCookies}
              className="px-6 py-2 bg-gradient-to-r from-hot-pink to-accent-purple text-white rounded-lg hover:opacity-90 transition-opacity"
            >
              Akzeptieren
            </button>
            <button
              onClick={declineCookies}
              className="px-6 py-2 bg-white/10 text-white rounded-lg hover:bg-white/20 transition-colors"
            >
              Ablehnen
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
